import assets from './assets';
import transcodings from './transcodings';
import conversions from './conversions';
import lives from './lives';
import categories from './categories';
import clips from './clips';
import drm from './drm';
import encoderStatus from './encoder-status';

export default [
    ...assets,
    ...transcodings,
    ...conversions,
    ...lives,
    ...categories,
    ...clips,
    ...drm,
    ...encoderStatus,
];
